"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandler = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const hooks_1 = require("./hooks");
const store_1 = require("./store");
const core_1 = require("./core");
const error_message_1 = require("./error_message");
const ErrorHandler = props => {
    let errorCode = (0, react_redux_1.useSelector)(state => {
        var _a, _b;
        const sourceId = (_a = state.widget) === null || _a === void 0 ? void 0 : _a.snapshot.sourceId;
        const widgetState = state;
        if (sourceId === null || sourceId === void 0 ? void 0 : sourceId.startsWith('mir')) {
            return (_b = core_1.Selectors.getMirrorPack(widgetState, sourceId || '')) === null || _b === void 0 ? void 0 : _b.errorCode;
        }
        if (state.errorCode) {
            return state.errorCode;
        }
        return null;
    });
    const themeName = (0, react_redux_1.useSelector)(state => {
        const widgetState = state;
        return widgetState.theme;
    });
    const { sourceId } = (0, hooks_1.useMeta)();
    const isLoading = (0, react_redux_1.useSelector)(state => {
        var _a, _b, _c, _d;
        if (errorCode) {
            return false;
        }
        if (sourceId === null || sourceId === void 0 ? void 0 : sourceId.startsWith('mir')) {
            return !((_b = (_a = state.mirrorMap) === null || _a === void 0 ? void 0 : _a[sourceId]) === null || _b === void 0 ? void 0 : _b.mirror) || !((0, store_1.getWidgetDatasheet)(state) && ((_c = state.widget) === null || _c === void 0 ? void 0 : _c.snapshot));
        }
        return !((0, store_1.getWidgetDatasheet)(state) && ((_d = state.widget) === null || _d === void 0 ? void 0 : _d.snapshot));
    });
    // here to intercept the case in the mirror has permission source table without permission,
    // because the loading is completed,
    // but the mirror load causes the source table data to overwrite the errorCode of the datasheet source table resulting in permission penetration
    errorCode = (0, react_redux_1.useSelector)(state => {
        const datasheet = (0, store_1.getWidgetDatasheet)(state);
        if (!errorCode && !isLoading && !(sourceId === null || sourceId === void 0 ? void 0 : sourceId.startsWith('mir')) && !(datasheet === null || datasheet === void 0 ? void 0 : datasheet.permissions.readable)) {
            return core_1.StatusCode.NODE_NOT_EXIST;
        }
        return errorCode;
    });
    if (isLoading) {
        return react_1.default.createElement("h1", { style: {
                fontSize: 14,
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
            } }, "loading\u2026\u2026");
    }
    if (errorCode) {
        return (react_1.default.createElement(error_message_1.ErrorMessage, { errorCode: errorCode, themeName: themeName }));
    }
    return (props.children || null);
};
exports.ErrorHandler = ErrorHandler;
